<script>

import { Overlay } from '../../'

export default {
    name: 'VisualTrading',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'Mano', version: '1.0.0',
                desc: 'VisualTrading',
                group: 'VT',
                preset: {
                    name: 'VisualTrading $smaLength, $dcLength, $riskRewardRatio',
                    side: 'onchart',
                    settings: {
                        smaLength: 50,
                        dcLength: 20,
                        riskRewardRatio: 3,
                        showPendingTarget: true,
                        lineWidth: 2
                    }
                }
            }
        },
        use_for() { return ['VisualTrading'] },
        calc() {
            return {
                props: {
                    smaLength: { def: 50, text: 'SMA Length' },
                    dcLength: { def: 20, text: 'DC Length' },
                    riskRewardRatio: { def: 3, text: 'Risk Reward Ratio' },
                    showPendingTarget: { def: true, text: 'Show Pending Target' }
                },
                conf: { renderer: 'VT' }
            }
        }
    }
}
</script>
